module.exports = __webpack_public_path__ + "img/train-3.aa4c42d5.jpg";